<template>
    <div class="knowledge-nav">
        <div class="container">
            <div class="row">
                <div class="col-12">

                    <template v-if="loading">
                        <loader />
                    </template>
                    <template v-else>

                        <h3 class="d-flex justify-content-center align-items-center" v-if="!categories.length">
                            {{$store.getters.t('blog_knowledge_nav_no_categories')}}
                        </h3>

                        
                        <div class="knowledge-nav__grid d-flex" v-else>

                            <a 
                                v-for="category in categories" :key="category.id"
                                :href="`/blog/${category.slug}`" class="knowledge-nav__item d-flex"
                                :style="{'--background': category.bg_color}"
                            >
                                <template v-if="category.icon && category.icon.path">
                                    <div class="knowledge-nav__icon d-flex">
                                        <img :src="handleIconPath(category.icon.path)" alt="">
                                    </div>
                                </template>
                                <div class="knowledge-nav__title" v-text="category.name"></div>
                            </a>

                        </div>

                    </template>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

import { getCategories } from './api.js'
import Loader from '../LoaderBalls.vue'

export default {
    name: "BlogKnowledgeNav",
    components: { Loader },
    data(){
        return{
            categories: [],
            loading: true
        }
    },

    mounted(){
        this.getCategories()
    },

    methods: {

        handleIconPath( icon ){
            return ( `/storage/${icon}` ).replace( 'original', 'avatar' )
        },

        async getCategories(){
            this.loading = true
            try{

                let { data, success } = await getCategories()  

                if( success ) {
                    this.categories = data
                }

                this.loading = false

            }
            catch( error ){

                this.loading = false

            }

        }

    }

}
</script>
<style lang="scss" scoped>

    @import '../../../sass/components/knowledge-nav';


    .knowledge-nav .LoaderBalls{
        min-height: 120px;
    }

    .knowledge-nav__icon{
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img{
            width: 100%;
            height: auto;
        }

    }

    @media screen and ( max-width: 768px ) {
        .knowledge-nav__item .knowledge-nav__icon,
        .knowledge-nav__item:hover .knowledge-nav__icon{
            background: transparent;
        }
    }

</style>
